import {
  type DocumentSummary,
  type DocumentSummaryVersion,
  type SharedDocumentSummary,
} from "~/api/types";

/**
 * A document shared by an ancestor, shaped as a library row. Parent metadata
 * (owner, publisher, category, tags, links) is deliberately blank — receivers
 * never see it. `adoptedAt` is the receiving group's own adoption.
 */
export const sharedDocumentToLibraryRow = (
  shared: SharedDocumentSummary,
): DocumentSummary => {
  const version: DocumentSummaryVersion = {
    id: shared.latestPublishedVersion.id,
    title: shared.latestPublishedVersion.title,
    status: shared.latestPublishedVersion.status,
    fileType: shared.latestPublishedVersion.fileType,
    isWorkflowOngoing: false,
    reviewFrom: null,
    reviewTo: null,
    fileUpdatedAt: null,
    publishedAt: shared.latestPublishedVersion.publishedAt,
    adoptedAt: shared.adoption?.adoptedAt ?? null,
    createdAt: shared.latestPublishedVersion.createdAt,
  };

  return {
    id: shared.documentId,
    name: shared.latestPublishedVersion.title,
    referenceNumber: null,
    tier: null,
    category: { id: 0, title: "-" },
    owner: { userId: 0, firstName: "-", email: "" },
    publisher: null,
    tags: [],
    parentDocumentIds: [],
    childDocumentIds: [],
    sharedToCompanyGroupIds: [],
    chartOrder: null,
    scheduleReviewPeriod: null,
    archivedAt: null,
    latestVersion: version,
    latestPublishedVersion: version,
    sharedBy: shared.sharedBy,
  };
};
